(function () {
  if (window.__kachingPriceSyncLoaded) return;
  window.__kachingPriceSyncLoaded = true;

  var syncFrame = null;
  var observedBlock = null;
  var blockObserver = null;

  function getText(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getSelectedBar() {
    var checkedInput = document.querySelector('.kaching-bundles__bar input:checked');

    return (
      document.querySelector('.kaching-bundles__bar--selected') ||
      (checkedInput ? checkedInput.closest('.kaching-bundles__bar') : null) ||
      null
    );
  }

  function getPriceRoot(selectedBar) {
    var productInfo = (selectedBar ? selectedBar.closest('product-info') : null) || document.querySelector('product-info');
    return (productInfo ? productInfo.querySelector('[id^="price-"]') : null) || document.querySelector('[id^="price-"]');
  }

  function getPerItemPriceSource(selectedBar) {
    return (
      (selectedBar ? selectedBar.querySelector('.kaching-bundles__bar-title .money') : null) ||
      (selectedBar ? selectedBar.querySelector('.kaching-bundles__bar-title') : null) ||
      null
    );
  }

  function copyPrice(source, target) {
    if (!source || !target) return false;

    var sourceMoney = source.classList && source.classList.contains('money') ? source : source.querySelector('.money');
    var sourceText = getText(sourceMoney || source);

    if (!sourceText) return false;

    if (target.dataset.kachingSyncedPrice === sourceText) return false;

    if (sourceMoney) {
      target.innerHTML = sourceMoney.outerHTML;
    } else {
      target.textContent = sourceText;
    }

    target.dataset.kachingSyncedPrice = sourceText;
    return true;
  }

  function syncSelectedBundlePrice() {
    var selectedBar = getSelectedBar();
    var priceRoot = getPriceRoot(selectedBar);
    var priceSource = getPerItemPriceSource(selectedBar);

    if (!selectedBar || !priceRoot || !priceSource) return;

    var salePrice =
      priceRoot.querySelector('.price__sale .price-item--sale.price-item--last') ||
      priceRoot.querySelector('.price__sale .price-item--sale') ||
      priceRoot.querySelector('.price-item--sale');

    var regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');

    copyPrice(priceSource, salePrice);
    copyPrice(priceSource, regularPrice);
  }

  function scheduleSync(delay) {
    if (delay) {
      window.setTimeout(syncSelectedBundlePrice, delay);
      return;
    }

    if (syncFrame) return;
    syncFrame = window.requestAnimationFrame(function () {
      syncFrame = null;
      syncSelectedBundlePrice();
    });
  }

  function observeKachingBlock() {
    var block = document.querySelector('.kaching-bundles');
    if (!block || block === observedBlock) return;

    observedBlock = block;

    if (blockObserver) blockObserver.disconnect();
    blockObserver = new MutationObserver(function () {
      scheduleSync(0);
    });
    blockObserver.observe(block, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });

    scheduleSync(0);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.kaching-bundles')) return;
      scheduleSync(0);
      scheduleSync(150);
      scheduleSync(500);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!event.target.closest('.kaching-bundles')) return;
      scheduleSync(0);
      scheduleSync(150);
    },
    true
  );

  var pageObserver = new MutationObserver(function () {
    observeKachingBlock();
  });
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    observeKachingBlock();
    scheduleSync(0);
  });

  window.addEventListener('load', function () {
    observeKachingBlock();
    scheduleSync(0);
    scheduleSync(500);
  });

  observeKachingBlock();
  scheduleSync(0);
})();
